import queryString from 'query-string';

export interface AuthenticationQueryParams {
    authorizedRepresentativeId?: string;
    candidateFirstName?: string;
    candidateLastName?: string;
}

export function parseAuthenticationQueryParams(search: string): AuthenticationQueryParams {
    return queryString.parse(search) as unknown as AuthenticationQueryParams;
}



// WEBPACK FOOTER //
// ./src/dtos/query-params.ts